import React, {FC} from 'react';
import cn from 'classnames';

import './VerticalSeparator.scss';

export const VerticalSeparator: FC<JSX.IntrinsicElements['div']>
  = ({className, ...props}) => <div {...props} className={cn(className, '__VerticalSeparator')} />;
